import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/alert/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/autocomplete/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/badge/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/breadcrumbs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/calendar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/chip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/date-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/date-picker/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/drawer/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/dropdown/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/form/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/image/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/input-otp/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/listbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/navbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/pagination/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/radio/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/ripple/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/scroll-shadow/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/skeleton/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/snippet/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/table/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Divider&wildcard!=!/app/node_modules/@nextui-org/user/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/call.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ae.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/es.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/fr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ge.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/gr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ua.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/eur.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/controls/location-pin.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/email.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/whats-app.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/pages/Contacts/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToAnchorLink"] */ "/app/src/components/ui/ScrollToAnchorLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Communication"] */ "/app/src/components/widgets/Communication/Communication.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/app/src/components/widgets/ContactForm/ContactForm.tsx");
